import { render, staticRenderFns } from "./ConfigurationTool.vue?vue&type=template&id=b5ad72f4&"
import script from "./ConfigurationTool.vue?vue&type=script&lang=js&"
export * from "./ConfigurationTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports